import { useState, useEffect } from 'react';
import { CollapsibleSection, SavedTip, inputCls, labelCls, selectCls } from './shared';
import { useSettingStore } from '../../../stores/settingStore';

export default function GeneralPanel() {
  const { settings, loading, updateSettings, fetchSettings } = useSettingStore();
  const [lang, setLang] = useState(settings.language);
  const [timezone, setTimezone] = useState(settings.timezone);
  const [dateFormat, setDateFormat] = useState(settings.dateFormat);
  const [currency, setCurrency] = useState(settings.currency);
  const [defaultPageSize, setDefaultPageSize] = useState(settings.defaultPageSize.toString());
  const [defaultNoteTemplate, setDefaultNoteTemplate] = useState(settings.defaultNoteTemplate ?? '');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  useEffect(() => {
    setLang(settings.language);
    setTimezone(settings.timezone);
    setDateFormat(settings.dateFormat);
    setCurrency(settings.currency);
    setDefaultPageSize(settings.defaultPageSize.toString());
    setDefaultNoteTemplate(settings.defaultNoteTemplate ?? '');
  }, [settings]);

  const handleSave = async () => {
    const updates = {
      language: lang,
      timezone,
      dateFormat,
      currency,
      defaultPageSize: parseInt(defaultPageSize),
      defaultNoteTemplate,
    };

    const { error } = await updateSettings(updates);
    if (!error) {
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    }
  };

  return (
    <div className="space-y-3 md:space-y-6">
      <CollapsibleSection title="语言与地区">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>界面语言</label>
            <select value={lang} onChange={e => setLang(e.target.value)} className={selectCls}>
              <option value="zh-CN">简体中文</option>
              <option value="zh-TW">繁體中文</option>
              <option value="en">English</option>
            </select>
          </div>
          <div>
            <label className={labelCls}>时区</label>
            <select value={timezone} onChange={e => setTimezone(e.target.value)} className={selectCls}>
              <option value="Asia/Shanghai">Asia/Shanghai (UTC+8)</option>
              <option value="Asia/Hong_Kong">Asia/Hong_Kong (UTC+8)</option>
              <option value="UTC">UTC (UTC+0)</option>
            </select>
          </div>
          <div>
            <label className={labelCls}>日期格式</label>
            <select value={dateFormat} onChange={e => setDateFormat(e.target.value)} className={selectCls}>
              <option value="YYYY-MM-DD">2025-03-24</option>
              <option value="DD/MM/YYYY">24/03/2025</option>
              <option value="MM/DD/YYYY">03/24/2025</option>
            </select>
          </div>
          <div>
            <label className={labelCls}>货币单位</label>
            <select value={currency} onChange={e => setCurrency(e.target.value)} className={selectCls}>
              <option value="CNY">人民币（CNY ¥）</option>
              <option value="USD">美元（USD $）</option>
              <option value="HKD">港币（HKD HK$）</option>
            </select>
          </div>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="订单默认配置" defaultOpen={false}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>每页显示条数</label>
            <select
              className={selectCls}
              value={defaultPageSize}
              onChange={e => setDefaultPageSize(e.target.value)}
            >
              <option value="10">10 条</option>
              <option value="20">20 条</option>
              <option value="50">50 条</option>
              <option value="100">100 条</option>
            </select>
          </div>
          <div className="col-span-1 sm:col-span-2">
            <label className={labelCls}>默认备注模板</label>
            <input
              type="text"
              className={inputCls}
              placeholder="新建订单时自动填入的备注内容..."
              value={defaultNoteTemplate}
              onChange={e => setDefaultNoteTemplate(e.target.value)}
            />
          </div>
        </div>
      </CollapsibleSection>

      {saved && <SavedTip />}
      <div className="flex justify-end pt-1">
        <button
          type="button"
          onClick={handleSave}
          disabled={loading}
          className="w-full sm:w-auto px-6 py-3 sm:py-2.5 bg-teal-500 hover:bg-teal-600 text-white text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <i className="ri-loader-4-line animate-spin" />
              保存中...
            </>
          ) : (
            '保存设置'
          )}
        </button>
      </div>
    </div>
  );
}
